import React from 'react';
import 'rodal/lib/rodal.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import ToastNotifications from 'react-notify-toast';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import './App.css';
import store from './store/configureStore';
import Container from './components/layout/Container';
import Navbar from './components/navbar/Navbar';
import Dialog from './components/layout/Dialog';
import { TrackingAnalytics } from './analytics/TrackingAnalytics';
import ErrorBoundary from './components/layout/ErrorBoundary';
import DevtoolsDialog from './devtools/DevtoolsDialog';
import { DEBUGGING } from './constants';
import { NavigationUtils } from './util/NavigationUtils';
import { BrowserChecker } from './BrowserChecker';
import { InteractiveHelp } from './analytics/InteractiveHelp';
import { CookieBanner } from './gdpr/CookieBanner';
import intercomChatIcon from './images/intercom-chat-icon.png';

export default class App extends React.Component {

  constructor(props) {
    super(props);

    TrackingAnalytics.init();
    InteractiveHelp.init();

    if (BrowserChecker.isLegacy()) {
      NavigationUtils.routeToLegacy('/legacy');
    }
  }

  render() {
    return (
      <Provider store={store}>
        <DndProvider backend={HTML5Backend}>
          <Router>
            <ErrorBoundary>
              <Navbar />
              <ErrorBoundary>
                <Container />
                <Dialog />
                <ToastNotifications />
                <CookieBanner />
                {DEBUGGING && <DevtoolsDialog />}
                <div
                  id="intercom_chat_icon"
                  className="launch_intercom_chat visible"
                  style={{
                    zIndex: 222222,
                    backgroundImage: `url(${intercomChatIcon})`
                  }} />
              </ErrorBoundary>
            </ErrorBoundary>
          </Router>
        </DndProvider>
      </Provider>
    );
  }
}
